import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { VehicleTemplateFilterEntity } from '../../domain/entities/VehicleTemplateFilterEntity'
export class VehicleFilterModel extends VehicleTemplateFilterEntity {
  maxConcurrentDelivery?: number
  constructor(dataDto: VehicleTemplateFilterEntity) {
    super()
    mapEntityProperties<VehicleFilterModel>(this, dataDto, {
      map: {
        maxConcurrentDelivery: dataDto.maxConcurrentShipment
      }
    })
  }
}
